import { createStore, applyMiddleware, compose } from 'redux';
import rootSaga from './rootSaga';
import rootReducer from './rootReducer';
import rootMiddleware from './rootMiddleware';
import { createBrowserHistory, createMemoryHistory } from 'history';
import createSagaMiddleware from 'redux-saga';
import { responsiveStoreEnhancer } from 'redux-responsive';
import { createReduxHistoryContext } from 'redux-first-history';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: process.env.NODE_ENV !== 'test' ? createBrowserHistory() : createMemoryHistory(),
});

const composeEnhancers =
  process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;

/* middleware that needs to live outside the rootMiddleware */
//const history = process.env.NODE_ENV !== 'test' ? createBrowserHistory() : createMemoryHistory();
const sagaMiddleware = createSagaMiddleware();
let store = {};

function configureStore(preloadedState) {
  const middleware = rootMiddleware([sagaMiddleware, routerMiddleware]);
  const store = createStore(
    rootReducer(routerReducer),
    preloadedState,
    composeEnhancers(responsiveStoreEnhancer, applyMiddleware.apply(null, middleware)),
  );

  if (module.hot)
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default;
      store.replaceReducer(nextRootReducer);
    });

  return store;
}

function resetStore() {
  store = configureStore({});
}

store = configureStore({});
const history = createReduxHistory(store);
sagaMiddleware.run(rootSaga);

export { store, resetStore, history };
export default store;
